/*
 *
 * Selectors for RestaurantDeals
 *
 */

import { createSelector } from 'reselect';
import { immutableToJS } from '../../devUtils/commonUtils';

const selectRestaurantDealsDomain = (state) => state.get('restaurantDealsPage');

export const selectRestaurantsDealsPage = () => createSelector(
  selectRestaurantDealsDomain,
  (restaurantsPage) => restaurantsPage,
);

export const selectRestaurantsDeals = () => createSelector(
  selectRestaurantDealsDomain,
  (restaurantsPage) => immutableToJS(restaurantsPage.get('gddPage')),
);

export const selectSearchRestaurantKey = () => createSelector(
  selectRestaurantDealsDomain,
  (restaurantsPage) => restaurantsPage.get('gddSearch'),
);



// WEBPACK FOOTER //
// client/containers/RestaurantDeals/selectors.js